<template>
  <div v-if="currency !== 'USD'" class="current-currency-wrapper">
    <div class="label">{{ trans("modals.currency_modal.selected_currency") }}</div>
    <div class="currency-item" @click="setCurrency('USD')">
      <div class="currency-item__img">
        <img class="img" :src="currencyItem.flag_image" :alt="currencyItem.abbr" />
      </div>
      <div class="currency-short">{{ currencyItem.abbr }}</div>
      <div class="currency-name">{{ currencyItem.name }}</div>
      <div class="clear-wrapper">
        <div class="clear-label">{{ trans("modals.currency_modal.clear_currency") }}</div>

        <div class="icon-custom-close">
          <span class="close-row"></span>
          <span class="close-row"></span>
        </div>
      </div>
    </div>
  </div>
  <div class="currency-list">
    <template v-for="currency in currencies" :key="currency.abbr">
      <div class="currency-item" @click="setCurrency(currency.abbr)">
        <div class="currency-item__img">
          <img class="img" :src="currency.flag_image" :alt="currency.abbr" />
        </div>
        <div class="currency-short">{{ currency.abbr }}</div>
        <div class="currency-name">{{ currency.name }}</div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { trans } from "@/utils/trans";

  const emit = defineEmits(["closeForm", "changeTitle", "setModalHeightAuto"]);

  const auctionStore = useAuctionStore();

  const currency = computed(() => {
    return auctionStore.currency;
  });

  const currencies = computed(() => {
    return auctionStore.currencies;
  });

  const currencyItem = computed(() => {
    return currencies.value?.find((item) => item.abbr === currency.value);
  });

  const setCurrency = (value) => {
    auctionStore.$patch({
      currency: value,
      isCurrencyBase: currencies.value?.find((item) => item.abbr === currency.value).is_base
    });

    emit("closeForm");
  };
</script>

<style lang="scss" scoped>
  .currency-list {
    font-family: "Montserrat", sans-serif;
    color: #707070;
  }
  .currency-item {
    padding: 10px 16px;
    display: flex;
    align-items: center;
    transition: 0.2s all linear;
    cursor: pointer;

    &:nth-child(odd) {
      background-color: #f9f9f9;
    }

    &:hover {
      background-color: #e6f2ff;
    }
  }
  .currency-short {
    font-size: 18px;
    line-height: 1;
    margin-left: 15px;
  }
  .currency-name {
    font-size: 16px;
    line-height: 1;
    margin-left: auto;
  }
  .currency-item__img {
    width: 28px;
    height: 28px;
  }
  .currency-description {
    display: block;
    margin-bottom: 32px;
  }
  .current-currency-wrapper {
    border-bottom: 1px solid #dddddd;
    padding-bottom: 22px;
    margin-bottom: 22px;

    .label {
      font-weight: 500;
      margin-bottom: 22px;
    }
    .currency-item {
      background-color: #f9f9f9;

      .clear-wrapper {
        display: none;
        margin-left: auto;
        align-items: center;
        color: #003559;

        .icon-custom-close {
          margin-top: 2px;
          margin-left: 10px;
          width: 13px;
          height: 13px;

          .close-row {
            width: 16px;
            background-color: #003559;
          }

          &:hover {
            transform: unset;
          }
        }
      }

      &:hover {
        background-color: #e6f2ff;

        .currency-name {
          display: none;
        }
        .clear-wrapper {
          display: flex;
        }
      }
    }
  }

  @media (max-width: 475px) {
    .currency-item {
      padding: 10px;
    }
    .currency-short {
      font-size: 16px;
    }
    .currency-name {
      font-size: 14px;
    }
    .currency-item__img {
      width: 24px;
      height: 24px;
    }
  }
</style>
